import { Auth0Client } from "@auth0/auth0-spa-js";
import { auth0Config } from "../../config";
import TermsClient from "./TermsClient";
import {
  AcceptTermsPayload,
  TermsAcceptance,
  TermsAcceptanceStatus,
  TermsVersion,
} from "../../types/terms";

class TermsApi {
  private client: TermsClient;

  constructor() {
    const auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
    this.client = new TermsClient(auth0Client);
  }

  getCurrent(typeKey: string): Promise<TermsVersion | null> {
    return this.client.getCurrent(typeKey);
  }

  getAcceptanceStatus(
    organizationId: string,
    termsTypeKey?: string,
  ): Promise<TermsAcceptanceStatus> {
    return this.client.getAcceptanceStatus(organizationId, termsTypeKey);
  }

  listAcceptances(
    organizationId: string,
    options?: { termsTypeKey?: string; includeSignature?: boolean },
  ): Promise<TermsAcceptance[]> {
    return this.client.listAcceptances(organizationId, options);
  }

  getVersion(versionId: string): Promise<TermsVersion> {
    return this.client.getVersion(versionId);
  }

  accept(versionId: string, payload: AcceptTermsPayload): Promise<unknown> {
    return this.client.accept(versionId, payload);
  }
}

export default TermsApi;
